import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function InfoIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 9V7H13V9H11ZM11 17V11H13V17H11Z" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default InfoIcon;
